import { Button } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import LocalModal from 'components/base/local-modal';
import { apiService } from 'services/base.service';
import FileUploader from 'components/base/file-uploader';
import useDashboardContext from 'contexts/dashboard.context';
import { handleApiError } from 'utils/functions';

const NewBusinessModal = ({ show, onClose }: { show: boolean; onClose: () => void }) => {
  const [companyLogo, setCompanyLogo] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const inputFields = [
    { label: 'Company name', name: 'company_name', placeholder: 'Donatus Globos Limited' },
    { label: 'CAC number', name: 'cac_number', placeholder: 'RC1014561' },
    { label: 'Company address', name: 'company_address', placeholder: 'City' },
    { label: 'Company email', name: 'company_email', placeholder: 'donatusglobusltd@gmail.com' }
  ];
  const [formData, setFormData] = useState({
    company_name: '',
    cac_number: '',
    company_address: '',
    company_email: ''
  });
  const { activeCompany, refetchCompanyList } = useDashboardContext();
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const data = {
      user_id: activeCompany.user_id,
      name: formData.company_name,
      cac: formData.cac_number,
      address: formData.company_address,
      email: formData.company_email,
      logo: companyLogo?.[0]
    };

    try {
      setLoading(true);
      await apiService.post(`company`, { data });
      toast(<ToastMessage type='success' message='Business has been added successfully' />);
      await refetchCompanyList();
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
      onClose();
    }
  };
  return (
    <div>
      <LocalModal
        isOpen={show}
        title='Add new business'
        description={``}
        titleIconColor='danger'
        onRequestClose={() => onClose()}
        footer={
          <div className='flex justify-end'>
            <Button
              className='w-[130px]'
              color='primary'
              small
              variant='block'
              loading={loading}
              onClick={handleSubmit}>
              Confirm
            </Button>
          </div>
        }>
        <div>
          {inputFields.map(({ label, placeholder, name }, index) => (
            <div key={index}>
              <p className='font-medium mb-2'>{label}</p>
              <input
                className='w-full focus:outline-none border-b-2 border-[#D5D6D7] py-3 mb-6 pl-[14px]'
                name={name}
                placeholder={placeholder}
                value={formData[name as keyof typeof formData]} // Cast name to a keyof typeof formData
                onChange={handleInputChange}
              />
            </div>
          ))}
          <FileUploader fileUrls={companyLogo} setFileUrls={setCompanyLogo} />
        </div>
      </LocalModal>
    </div>
  );
};

export default NewBusinessModal;
